export default {
    name: "slider",
    props: ['photos'],
    methods:{
        // Photo carousel: Get the actual slide index that a dot represents (0-4 for the 5 dots)
        getPhotoDotSlideIndex(dotIndex) {
            const totalSlides = this.photos.length;
            const lastSlideIndex = totalSlides - 1;
            
            if (totalSlides <= 5) {
            return dotIndex < totalSlides ? dotIndex : lastSlideIndex;
            }
            
            if (this.currentPhotoSlide === 0) {
            if (dotIndex === 0) return 0;
            if (dotIndex === 4) return lastSlideIndex;
            return dotIndex;
            } else if (this.currentPhotoSlide === lastSlideIndex) {
            if (dotIndex === 0) return 0;
            if (dotIndex === 4) return lastSlideIndex;
            return lastSlideIndex - (4 - dotIndex);
            } else if (this.currentPhotoSlide === 1) {
            if (dotIndex === 0) return 0;
            if (dotIndex === 4) return lastSlideIndex;
            return dotIndex;
            } else if (this.currentPhotoSlide === lastSlideIndex - 1) {
            if (dotIndex === 0) return 0;
            if (dotIndex === 4) return lastSlideIndex;
            return lastSlideIndex - (4 - dotIndex);
            } else {
            if (dotIndex === 0) return 0;
            if (dotIndex === 4) return lastSlideIndex;
            if (dotIndex === 1) return this.currentPhotoSlide - 1;
            if (dotIndex === 2) return this.currentPhotoSlide;
            if (dotIndex === 3) return this.currentPhotoSlide + 1;
            }
            return 0;
        },

        // Photo carousel: Get classes for a dot based on its index (0-4)
        getPhotoDotClasses(dotIndex) {
            const totalSlides = this.photos.length;
            const lastSlideIndex = totalSlides - 1;
            const actualSlideIndex = this.getPhotoDotSlideIndex(dotIndex);
            const isActive = actualSlideIndex === this.currentPhotoSlide;
            
            const classes = {};
            
            if (isActive) {
            classes.active = true;
            } else {
            if (this.currentPhotoSlide === 0) {
                if (dotIndex === 4) classes['dot-small'] = true;
            } else if (this.currentPhotoSlide === 1) {
                if (dotIndex === 4) classes['dot-small'] = true;
            } else if (this.currentPhotoSlide === lastSlideIndex) {
                if (dotIndex === 0) classes['dot-small'] = true;
            } else if (this.currentPhotoSlide === lastSlideIndex - 1) {
                if (dotIndex === 0) classes['dot-small'] = true;
            } else {
                if (dotIndex === 0 || dotIndex === 4) classes['dot-small'] = true;
            }
            }
            
            return classes;
        },

        // Photo carousel: Navigate to the slide represented by a dot
        goToPhotoDotSlide(dotIndex) {
            const actualSlideIndex = this.getPhotoDotSlideIndex(dotIndex);
            this.currentPhotoSlide = actualSlideIndex;
        },

        onTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
            this.isDragging = true;
        },
        onTouchMove(event) {
            if (!this.isDragging) return;
            
            this.touchCurrentX = event.touches[0].clientX;
            const deltaX = this.touchCurrentX - this.touchStartX;
            const deltaY = Math.abs(event.touches[0].clientY - this.touchStartY);
            
            // Only handle horizontal swipes
            if (Math.abs(deltaX) > deltaY) {
            event.preventDefault();
            }
        },
        onTouchEnd(event) {
            if (!this.isDragging) return;
            
            const deltaX = this.touchCurrentX - this.touchStartX;
            const threshold = 50; // Minimum distance for swipe
            
            if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0 && this.currentPhotoSlide > 0) {
                // Swipe right - go to previous photo
                this.currentPhotoSlide--;
            } else if (deltaX < 0 && this.currentPhotoSlide < this.photos.length - 1) {
                // Swipe left - go to next photo
                this.currentPhotoSlide++;
            }
            }
            this.isDragging = false;
        },
    },
    data () {
        return{
            touchStartX: 0,
            touchStartY: 0,
            touchCurrentX: 0,
            isDragging: false,
            currentPhotoSlide: 0,
        }
    },
}